export const HomeSvg = ()=>{
    return  <svg
                        width="20"
                        height="21"
                        viewBox="0 0 20 21"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M0.75 10.24V12.75C0.75 16.05 0.75 17.7 1.775 18.725C2.8 19.75 4.45 19.75 7.75 19.75H11.75C15.05 19.75 16.7 19.75 17.725 18.725C18.75 17.7 18.75 16.05 18.75 12.75V10.24C18.75 8.558 18.75 7.718 18.394 6.99C18.038 6.262 17.374 5.746 16.048 4.714L14.048 3.159C11.983 1.553 10.95 0.75 9.75 0.75C8.55 0.75 7.517 1.553 5.452 3.159L3.452 4.714C2.125 5.746 1.462 6.262 1.106 6.99C0.75 7.718 0.75 8.558 0.75 10.24ZM14.75 15.75V11.75V15.75Z"
                          fill="#121212"
                        />
                        <path
                          d="M14.75 15.75V11.75M0.75 10.24V12.75C0.75 16.05 0.75 17.7 1.775 18.725C2.8 19.75 4.45 19.75 7.75 19.75H11.75C15.05 19.75 16.7 19.75 17.725 18.725C18.75 17.7 18.75 16.05 18.75 12.75V10.24C18.75 8.558 18.75 7.718 18.394 6.99C18.038 6.262 17.374 5.746 16.048 4.714L14.048 3.159C11.983 1.553 10.95 0.75 9.75 0.75C8.55 0.75 7.517 1.553 5.452 3.159L3.452 4.714C2.125 5.746 1.462 6.262 1.106 6.99C0.75 7.718 0.75 8.558 0.75 10.24Z"
                          stroke="white"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
}

export const AssetsSvg = ()=>{
    return <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M12 0.75C16.268 0.75 20.5763 2.29089 22.5732 3.11719C22.9798 3.28553 23.25 3.6941 23.25 4.17676V15.8291C23.2499 16.2728 23.0146 16.683 22.6318 16.9072L12.6318 22.7617C12.2418 22.99 11.7582 22.99 11.3682 22.7617L1.36816 16.9072C0.985396 16.683 0.750078 16.2728 0.75 15.8291V4.17676C0.75 3.6941 1.02023 3.28553 1.42676 3.11719C3.42374 2.29089 7.73196 0.75 12 0.75Z"
                          stroke="#121212"
                          stroke-width="1.5"
                        />
                        <path
                          d="M11.9434 11.1001H12.0576L14.9307 6.43896H17.334L13.5479 12.2925H16V13.4634H13.0615V14.6343H16V15.8052H13.0615V16.9751H10.9395V15.8052H8V14.6343H10.9395V13.4634H8V12.2925H10.4531L6.66699 6.43896H9.07031L11.9434 11.1001Z"
                          fill="#121212"
                        />
                      </svg>
}

export const MessageSvg = ()=>{
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_81_1424)">
          <path
            d="M15 4.5H4.125C3.62772 4.5 3.15081 4.69754 2.79917 5.04917C2.44754 5.40081 2.25 5.87772 2.25 6.375V17.625C2.25 18.1223 2.44754 18.5992 2.79917 18.9508C3.15081 19.3025 3.62772 19.5 4.125 19.5H19.8155C20.3128 19.5 20.7897 19.3025 21.1413 18.9508C21.4929 18.5992 21.6905 18.1223 21.6905 17.625V11.2031"
            stroke="#121212"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></path>
          <path
            d="M5.25 7.5L12 12.75L16.0781 9.67172"
            stroke="#121212"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></path>
          <path
            d="M20.2477 8.24995C21.489 8.24995 22.4953 7.24364 22.4953 6.0023C22.4953 4.76095 21.489 3.75464 20.2477 3.75464C19.0063 3.75464 18 4.76095 18 6.0023C18 7.24364 19.0063 8.24995 20.2477 8.24995Z"
            fill="#121212"
          ></path>
          <path
            d="M20.2496 8.99995C19.6567 8.99995 19.0772 8.82414 18.5842 8.49476C18.0912 8.16537 17.707 7.6972 17.4801 7.14945C17.2533 6.6017 17.1939 5.99897 17.3096 5.41748C17.4252 4.83599 17.7107 4.30186 18.1299 3.88263C18.5492 3.4634 19.0833 3.1779 19.6648 3.06224C20.2463 2.94657 20.849 3.00594 21.3968 3.23282C21.9445 3.45971 22.4127 3.84393 22.7421 4.33689C23.0715 4.82985 23.2473 5.40942 23.2473 6.0023C23.2466 6.79713 22.9306 7.55924 22.3686 8.12127C21.8066 8.68331 21.0444 8.99933 20.2496 8.99995ZM20.2496 4.50464C19.9528 4.50418 19.6626 4.59176 19.4156 4.7563C19.1686 4.92084 18.976 5.15494 18.8621 5.42899C18.7482 5.70304 18.7182 6.00471 18.7758 6.29584C18.8334 6.58696 18.9761 6.85446 19.1858 7.06447C19.3955 7.27448 19.6627 7.41758 19.9538 7.47564C20.2448 7.53371 20.5465 7.50414 20.8207 7.39068C21.095 7.27722 21.3294 7.08496 21.4943 6.83824C21.6592 6.59151 21.7473 6.30141 21.7473 6.00464C21.7473 5.60722 21.5896 5.22604 21.3088 4.94481C21.028 4.66357 20.647 4.50526 20.2496 4.50464Z"
            fill="#121212"
          ></path>
        </g>
        <defs>
          <clipPath id="clip0_81_1424">
            <rect width="24" height="24" fill="white"></rect>
          </clipPath>
        </defs>
      </svg>
    );
}